import { consoleEvents } from '@pb/utils'
import { pipe, groupBy, prop, sort, descend, head, map, values } from 'ramda'
import { createReducer } from 'redux-act'

import * as actions from './actions'
import initialState from './initialState'

// ----------------------------------------
// FETCH NOTIFICATIONS
// ----------------------------------------
const fetchNotificationsStart = (state): any => ({
  ...state,
  isLoading: true,
})

const fetchNotificationsSuccess = (state, messages): any => {
  return {
    ...state,
    // Only add the latest message of each messageType and show latest message first
    messages: pipe(
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      groupBy(prop('messageType')),
      map(sort(descend(prop('occurredTime')))),
      map(head),
      values,
      sort(descend(prop('occurredTime'))),
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
    )(messages),
    isLoading: false,
    error: false,
    hasLoaded: true,
  }
}

const fetchNotificationsFail = (state, error): any => {
  consoleEvents.error(`Failed to load notifications: ${error}`)

  return {
    ...state,
    isLoading: false,
    error: true,
    hasLoaded: true,
  }
}

const markAsRead = (state, notificationEventIds): any => {
  return {
    ...state,
    messages: state.messages.map((message) =>
      notificationEventIds.includes(message.notificationEventId)
        ? { ...message, read: true }
        : message,
    ),
  }
}

const toggleInbox = (state): any => {
  return {
    ...state,
    isOpen: !state.isOpen,
  }
}

const reducer = createReducer((on) => {
  on(actions.fetchNotificationsStart, fetchNotificationsStart)
  on(actions.fetchNotificationsSuccess, fetchNotificationsSuccess)
  on(actions.fetchNotificationsFail, fetchNotificationsFail)
  on(actions.markAsRead, markAsRead)
  on(actions.toggleInbox, toggleInbox)
}, initialState)

export default reducer
